export var DatePreference = /*#__PURE__*/function (DatePreference) {
  DatePreference["Range"] = "Range";
  DatePreference["Exact"] = "Exact";
  DatePreference["Tba"] = "TBA";
  DatePreference["Season"] = "Season";
  DatePreference["None"] = "None";
  return DatePreference;
}({});
export var SeasonName = /*#__PURE__*/function (SeasonName) {
  SeasonName["Fall"] = "Fall";
  SeasonName["Winter"] = "Winter";
  SeasonName["Spring"] = "Spring";
  SeasonName["Summer"] = "Summer";
  return SeasonName;
}({});